import { FC } from 'react';

import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

interface Props {
   title?: string;
}

export const ProductFlyoutProductTitle: FC<Props> = ({ title }: Props) => {
   const translate = useTranslations();

   return (
      <Box direction="column" gap="2xs">
         <Typography component="span" variant="body-highlight">
            {translate('page-consumer.request-for-quotation.product')}
         </Typography>
         <Typography component="span" variant="body">
            {title}
         </Typography>
      </Box>
   );
};
